import { Col as ReactstrapCol, Container as ReactstrapContainer, Row as ReactstrapRow } from 'reactstrap';
import styled from 'styled-components';
import InlineSVG from 'svg-inline-react';

import { HorizontalProgressBar } from 'src/app/components/Elements/ProgressBars/HorizontalProgressBar';
import type { ThemeSpaceType } from 'src/styles/theme';

/*
  Layout Styles
 */
export const MainContainer = styled(ReactstrapContainer)`
  position: relative;
  max-width: 100%;
  min-height: calc(100vh - 8rem);
  display: flex;
  flex-direction: column;
`;

export const MainRow = styled(ReactstrapRow)<{ mainRowPaddingBottom?: ThemeSpaceType }>`
  flex: 1 1 auto;
  justify-content: center;
  padding-bottom: ${props =>
    props.mainRowPaddingBottom ? props.theme.space[props.mainRowPaddingBottom] : props.theme.space['14.4']};

  ${props => props.theme.mediaQueries.medium} {
    flex-wrap: nowrap;
    padding-top: ${props => props.theme.space['7.2']};
  }
  ${props => props.theme.mediaQueries.mediumDown} {
    display: flex;
    flex-direction: column;
  }
`;

export const MainSection = styled.div`
  width: 100%;

  ${props => props.theme.mediaQueries.medium} {
    max-width: 50.5rem;
    overflow: visible;
    padding-top: ${props => props.theme.space.none};
    padding-left: ${props => props.theme.space.none};
    padding-right: ${props => props.theme.space.none};
  }

  padding-top: ${props => props.theme.space.s7};
  padding-left: ${props => props.theme.space.s5};
  padding-right: ${props => props.theme.space.s5};
`;

/*
  Progress Bar Styles
 */

export const Sidebar = styled(ReactstrapCol)<{ hasVerticalProgressBar: boolean; hasHorizontalProgressBar: boolean }>`
  height: 0.5rem !important;

  position: ${({ hasVerticalProgressBar, hasHorizontalProgressBar }) =>
    hasVerticalProgressBar ? 'initial' : !hasHorizontalProgressBar ? 'fixed' : 'initial'};
  z-index: ${props => props.theme.zIndices.topOne};
  padding: ${props => props.theme.space.none} !important;

  ${props => props.theme.mediaQueries.medium} {
    padding: ${props => props.theme.space.none} ${props => props.theme.space.s7} !important;
    min-width: ${props => props.theme.space['24.0']};
    height: auto !important;
    position: ${({ hasVerticalProgressBar }) => (hasVerticalProgressBar ? 'relative' : 'initial')};
  }

  ${props => props.theme.mediaQueries.mediumDown} {
    flex: none;
  }
`;

export const AbsolutelyPositionedHorizontalProgressBar = styled(HorizontalProgressBar)`
  position: absolute;
  top: 0;
  left: 0;
`;

export const EmptyCol = styled(ReactstrapCol)`
  padding: ${props => props.theme.space.none};
  z-index: ${props => props.theme.zIndex.z0};

  ${props => props.theme.mediaQueries.medium} {
    flex-grow: 1;
  }
`;

/*
  Step Count Styles
*/

export const ChevronIcon = styled(InlineSVG)`
  width: ${props => props.theme.space.s3};
  height: ${props => props.theme.space.s3};
  transform: rotate(90deg);
  position: relative;
  top: ${props => props.theme.space['0.1']};
  & path {
    fill: ${props => props.theme.colors.capsuleGreen60};
  }
`;

export const PreviousButton = styled.button`
  display: flex;
  align-items: center;
  background: none;
  border: none;
  margin-right: ${props => props.theme.space['1.0']};
  color: ${props => props.theme.colors.capsuleGreen60};
  font-weight: ${props => props.theme.fontWeights.book};
  line-height: ${props => props.theme.space['2.0']};
  font-family: ${props => props.theme.fonts.circular};
  font-size: ${props => props.theme.fontSizes.body} !important;
  cursor: pointer;
`;

export const StyledStepCount = styled.div`
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
  margin-bottom: ${props => props.theme.space['2.1']};
  color: ${props => props.theme.colors.capsuleBlue50};
  font-weight: ${props => props.theme.fontWeights.book};
  line-height: ${props => props.theme.space['2.0']};
  font-family: ${props => props.theme.fonts.circular};
  font-size: ${props => props.theme.fontSizes.body} !important;
  & > p {
    font-weight: ${props => props.theme.fontWeights.semiBold} !important;
  }
`;

/*
Footer Styles
*/
export const FooterRow = styled(ReactstrapRow)`
  padding: 0 ${props => props.theme.space.s7} ${props => props.theme.space.s5};
  ${props => props.theme.mediaQueries.mediumDown} {
    padding: ${props => props.theme.space.none} ${props => props.theme.space.s7} ${props => props.theme.space.s7};
  }
`;
